import { all, call, fork, put, takeEvery, delay, select, take } from 'bukku/shared/SagaService';
import actions from './actions';
// import { message } from 'antd';
import { deleto, get, post } from 'bukku/shared/ApiService';
import { errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn } from "../helper";
import { t } from "@lingui/macro";
import { readLists } from '../Transaction/initTransaction/helper/readLists';
import { L } from '../List/reducer';
import { MyInvoisDocumentType } from '../../enums/MyInvoisDocumentType';
import { getServerUrl } from '../Transaction/helpers/getServerUrl';

const useDummyData = false;
const dummyMyInvoisDocumentPayload = {
    ID: "IV-00197",
    Items: [
        {
            Tax: [
                {
                    ID: "02",
                    Percent: 6,
                    // TaxableAmount: 100,
                    // TaxAmount: 6,
                },
                {
                    ID: "02",
                    Percent: 8,
                    // TaxableAmount: 100,
                    // TaxAmount: 8,
                },
                {
                    ID: "01",
                    Percent: 5,
                    // TaxableAmount: 100,
                    // TaxAmount: 5,
                },
                {
                    ID: "06",
                    Percent: 5,
                    // TaxableAmount: 100,
                    // TaxAmount: 5,
                },
            ],
            Description: "Lipton Tea",
            PriceAmount: 105,
            // AllowanceCharges: [
            //     {
            //         Amount: 5,
            //         ChargeIndicator: false,
            //         AllowanceChargeReason: "Discount Given",
            //     },
            // ],
            AllowanceCharges: null,
            InvoicedQuantity: 1,
            ProductTariffCode: null,
            ItemClassificationCodes: ["022"],
        },
        {
            Tax: [
                {
                    ID: "E",
                    Percent: 0,
                    TaxExemptionReason: "Exemption Schedule A",
                    TaxableAmountExempted: 1,
                },
                {
                    ID: "E",
                    Percent: 0,
                    TaxExemptionReason: "Exemption Schedule C (Item 3)",
                    TaxableAmountExempted: 1,
                },
            ],
            Description: "Lipton Tea",
            PriceAmount: 1,
            AllowanceCharges: null,
            InvoicedQuantity: 100,
            ProductTariffCode: null,
            ItemClassificationCodes: ["022"],
        },
    ],
    FtaData: null,
    Customer: { SST: "NA", TIN: "IG28717248010", Name: "JW", Email: "jianwen@bukku.my", Phone: "+60129988998", RegNo: "960428085067", Address: { Line1: "Apple Street", Line2: null, Line3: null, CityName: "Ipoh", PostalZone: "32000", CountrySubentityCode: "08", CountryIdentificationCode: "MYS" }, RegNoType: "NRIC" },
    Supplier: { SST: null, TIN: "IG28717248010", Name: "Bukku", Email: null, Phone: "+60167093579", RegNo: "960428085067", Address: { Line1: "12, Jln besar", Line2: null, Line3: null, CityName: "t", PostalZone: "12341", CountrySubentityCode: "03", CountryIdentificationCode: "MYS" }, RegNoType: "NRIC", TaxTourismNumber: "NA", IndustryClassificationCode: "06101", IndustryClassificationName: "Extraction of crude petroleum oils" },
    IssueDate: "2024-08-10",
    ExportData: null,
    ImportData: null,
    RoundingOn: true,
    ExchangeData: null,
    PaymentMeans: null,
    PaymentTerms: "NET30",
    TaxInclusive: false,
    DeliveryParty: null,
    IncotermsData: null,
    InvoicePeriodData: null,
};

const successKeys = [
    actions.MYINVOIS_READ_DOCUMENT_SUCCESS,
    actions.MYINVOIS_READ_ALL_DOCUMENTS_SUCCESS,
    actions.MYINVOIS_RESUBMIT_DOCUMENT_SUCCESS,
    actions.MYINVOIS_READ_ALL_TRANSACTIONS_SUCCESS,
    actions.MYINVOIS_READ_ALL_MINIPOS_SUCCESS,
    actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS,
    actions.MYINVOIS_CANCEL_DOCUMENT_SUCCESS,
    actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS,
    actions.MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS,
    actions.MYINVOIS_SUBMIT_TRANSACTION_SUCCESS,
    actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_SUCCESS,
    actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_SUCCESS,
    actions.MYINVOIS_SUBMIT_MINIPOS_SUCCESS,
    actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS,
    actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_SUCCESS,
    actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS,
    actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS,
    actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_SUCCESS,
];
const errorKeys = [
    actions.MYINVOIS_READ_DOCUMENT_ERROR,
    actions.MYINVOIS_READ_ALL_DOCUMENTS_ERROR,
    actions.MYINVOIS_RESUBMIT_DOCUMENT_ERROR,
    actions.MYINVOIS_READ_ALL_TRANSACTIONS_ERROR,
    actions.MYINVOIS_READ_ALL_MINIPOS_ERROR,
    actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_ERROR,
    actions.MYINVOIS_CANCEL_DOCUMENT_ERROR,
    actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_ERROR,
    actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_ERROR,
    actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_ERROR,
    actions.MYINVOIS_BULK_SUBMIT_MINIPOS_ERROR,
    actions.MYINVOIS_SUBMIT_TRANSACTION_ERROR,
    actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_ERROR,
    actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_ERROR,
    actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_ERROR,
    actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_ERROR,
    actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_ERROR,
    actions.MYINVOIS_READ_INCOMING_DOCUMENT_ERROR,
    actions.MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.MYINVOIS_RESUBMIT_DOCUMENT_SUCCESS:
            return t`The document has been resubmitted for validation.`;
        case actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS:
            return t`${action.result.total_count} document(s) have been resubmitted for validation.`;
        case actions.MYINVOIS_CANCEL_DOCUMENT_SUCCESS:
            return t`The consolidated document has been cancelled successfully.`;
        case actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS:
            return t`${action.result.total_count} transaction(s) have been submitted for validation.`;
        case actions.MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS:
            return t`${action.result.total_count} MiniPOS transaction(s) have been submitted for validation.`;
        case actions.MYINVOIS_SUBMIT_TRANSACTION_SUCCESS: {
            const actionText = action.isSubmit ? t`submitted` : t`resubmitted`;
            return t`The transaction has been ${actionText} for validation.`;
        }
        case actions.MYINVOIS_SUBMIT_MINIPOS_SUCCESS: {
            const actionText = action.isSubmit ? t`submitted` : t`resubmitted`;
            return t`The MiniPOS transaction has been ${actionText} for validation.`;
        }
        case actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS:
            return t`The transaction(s) have been submitted for consolidation.`;
        case actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_SUCCESS:
            return t`The MiniPOS transaction(s) have been submitted for consolidation.`;
        case actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_SUCCESS:
        case actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_SUCCESS:
            return t`The document status has been fetched successfully.`;
        default:
            return null;
    }
};

export function* readDocumentRequest() {
    yield takeEvery(actions.MYINVOIS_READ_DOCUMENT_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                if (useDummyData) {
                    yield delay(100);
                    // read tax codes to match the document's items' tax codes with ours
                    yield readLists([
                        L.classification_code_list,
                        L.countries,
                        L.state_list,
                        L.tax_codes,
                    ], { state_list: { country_code: 'MY' } });

                    const taxCodes = yield select(state => state.List.taxCodes);
                    const countries = yield select(state => state.List.countries);
                    const classificationCodeList = yield select(state => state.List.classificationCodeList);
                    const countryStates = yield select(state => state.List.countryStates);

                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_DOCUMENT_SUCCESS,
                        myInvoisDocument: {
                            id: 1,
                            number: "IV-000123",
                            contact_legal_name: null,
                            currency_code: "MYR",
                            exchange_rate: 1,
                            amount: 123.45,
                            transactions: [
                                {
                                    id: 2229,
                                    number: "IV-2229",
                                    date: "2024-08-04",
                                },
                                {
                                    id: 2234,
                                    number: "IV-2234",
                                },
                                {
                                    id: 2231,
                                    number: "IV-2231",
                                },
                                {
                                    id: 1895,
                                    number: "IV-1895",
                                },
                                {
                                    id: 2227,
                                    number: "IV-2227",
                                },
                                {
                                    id: 2226,
                                    number: "IV-2226",
                                },
                            ],
                            payload: dummyMyInvoisDocumentPayload,
                            document_uuid: "13JHFN02HE98Y",
                            long_id: "13JHFN02HE98Y287YEHRFBEURY7FGUHEIF3JR",
                            is_consolidated: false,
                            type: "sale_invoice",
                            status: "INVALID",
                            issued_at: "2024-08-04",
                            validated_at: "2024-08-04",
                            rejected_at: "2024-08-04",
                            reject_message: "Reject reason",
                            cancelled_at: "2024-08-04",
                            cancel_message: "Cancel reason",
                            rejected_reason: "LHDN REJECTED REASON IG",
                            created_at: "2024-08-04 14:19:42",
                            updated_at: "2024-08-04 14:19:42",
                        },
                        taxCodes,
                        countries,
                        classificationCodeList,
                        countryStates,
                    });
                }
                else {
                    const response = yield call(get, `/myinvois/documents/${id}`, null, context);
                    const data = yield response.data;

                    // read tax codes to match the document's items' tax codes with ours
                    yield readLists([
                        L.classification_code_list, L.countries, L.state_list, L.tax_codes,
                    ], { state_list: { country_code: 'MY' } });

                    const taxCodes = yield select(state => state.List.taxCodes);
                    const countries = yield select(state => state.List.countries);
                    const classificationCodeList = yield select(state => state.List.classificationCodeList);
                    const countryStates = yield select(state => state.List.countryStates);

                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_DOCUMENT_SUCCESS,
                        myInvoisDocument: data.myinvois_document,
                        taxCodes,
                        countries,
                        classificationCodeList,
                        countryStates,
                    });
                }
            });
    });
}

export function* readAllDocumentsRequest() {
    yield takeEvery(actions.MYINVOIS_READ_ALL_DOCUMENTS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_ALL_DOCUMENTS_SUCCESS,
                        // myInvoisDocuments: [
                        //     {
                        //         id: 1,
                        //         transaction: {
                        //             id: 102,
                        //             number: "MyInvois-DOC-001",
                        //             date: "2024-08-04",
                        //             contact_legal_name: "Dummy contact",
                        //             currency_code: "SGD",
                        //             exchange_rate: 3.5,
                        //             amount: 123,
                        //         },
                        //         consolidated_date: null,
                        //         type: "INVOICE",
                        //         status: "QUEUED",
                        //         created_at: "2024-08-04 14:19:42",
                        //         updated_at: "2024-08-04 14:19:42",
                        //     },
                        //     {
                        //         id: 2,
                        //         transaction: null,
                        //         consolidated_date: "2024-08-04 14:19:42",
                        //         type: "SELF_BILLED_CREDIT_NOTE",
                        //         status: "INVALID",
                        //         created_at: "2024-08-04 14:19:42",
                        //         updated_at: "2024-08-04 14:19:42",

                        //     },
                        // ],
                        myInvoisDocuments: [
                            {
                                id: 12,
                                number: "IV-0009",
                                contact_legal_name: "Dummy contact",
                                currency_code: "SGD",
                                exchange_rate: 3.123,
                                amount: 11.23,
                                is_consolidated: false,
                                type: MyInvoisDocumentType.INVOICE,
                                status: "ERROR",
                                issued_at: "2024-08-04 14:19:42",
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                                transaction_date: "2024-08-04",
                            },
                            {
                                id: 123,
                                number: "DF23JOJ",
                                contact_legal_name: null, // frontend put 'general public'
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 60,
                                is_consolidated: true,
                                type: MyInvoisDocumentType.SELF_BILLED_INVOICE,
                                status: "INVALID",
                                issued_at: "2024-08-04 14:19:42",
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                                transaction_date: "2024-08-04",
                            },
                        ],
                        pagination: {
                            current_page: 1,
                            per_page: 30,
                            total: 23,
                        },
                        request,
                    });
                }
                else {
                    const response = yield call(get, '/myinvois/documents', request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_ALL_DOCUMENTS_SUCCESS,
                        myInvoisDocuments: data.myinvois_documents,
                        pagination: data.paging,
                        request,
                    });
                }
            });
    });
}

export function* readIncomingDocumentRequest() {
    yield takeEvery(actions.MYINVOIS_READ_INCOMING_DOCUMENT_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/myinvois/incoming_documents/${id}`, null, context);
                const data = yield response.data;

                // read tax codes to match the document's items' tax codes with ours
                yield readLists([
                    L.classification_code_list, L.countries, L.state_list, L.tax_codes,
                ], { state_list: { country_code: 'MY' } });

                const taxCodes = yield select(state => state.List.taxCodes);
                const countries = yield select(state => state.List.countries);
                const classificationCodeList = yield select(state => state.List.classificationCodeList);
                const countryStates = yield select(state => state.List.countryStates);

                // OK
                yield put({
                    type: actions.MYINVOIS_READ_INCOMING_DOCUMENT_SUCCESS,
                    myInvoisIncomingDocument: data.myinvois_incoming_document,
                    taxCodes,
                    countries,
                    classificationCodeList,
                    countryStates,
                });
            });
    });
}

export function* postIncomingDocumentRequest() {
    yield takeEvery(actions.MYINVOIS_POST_INCOMING_DOCUMENT_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request, id }) {
                yield call(post, `/myinvois/incoming_documents/${id}/transactions`, request, context);
                // OK
                yield put({
                    type: actions.MYINVOIS_POST_INCOMING_DOCUMENT_SUCCESS,
                });
            });
    });
}

export function* readAllIncomingDocumentsRequest() {
    yield takeEvery(actions.MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                // filter need display Yes and No, Backend request accept true and false
                // filter not able to differentiate between true and false to display Yes and No
                // so we need to convert Yes and No to true and false here
                if (request.is_posted && request.is_posted === 'Yes')
                    request.is_posted = true;
                if (request.is_posted && request.is_posted === 'No')
                    request.is_posted = false;

                const response = yield call(get, '/myinvois/incoming_documents', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_SUCCESS,
                    myInvoisIncomingDocuments: data.myinvois_incoming_documents,
                    pagination: data.paging,
                    request,
                });
            });
    });
}

export function* deleteIncomingDocumentsRequest() {
    yield takeEvery(actions.MYINVOIS_DELETE_INCOMING_DOCUMENT_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                yield call(deleto, `/myinvois/incoming_documents/${id}`, null, context);
                // OK
                yield put({
                    type: actions.MYINVOIS_DELETE_INCOMING_DOCUMENT_SUCCESS,
                });
            });
    });
}

export function* resubmitDocumentRequest() {
    yield takeEvery(actions.MYINVOIS_RESUBMIT_DOCUMENT_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ documentId }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_RESUBMIT_DOCUMENT_SUCCESS,
                    });
                }
                else {
                    yield call(post, `/myinvois/documents/${documentId}/resubmit`, null, context);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_RESUBMIT_DOCUMENT_SUCCESS,
                    });
                }
            });
    });
}

export function* bulkResubmitDocumentsRequest() {
    yield takeEvery(actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ documentIds }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS,
                        result: {
                            total_count: 12,
                        },
                    });
                }
                else {
                    const response = yield call(post, `/myinvois/documents/resubmit`, { document_ids: documentIds }, context);
                    const data = yield response.data;

                    // Re-read the list here, so that myInvoisDocuments is udpated once MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS,
                    // and myInvoisDocuments can be used in MyInvoisBulkResubmitDocuments' onSuccess as 'dataSource' if needed
                    const { lastReadAllDocumentsRequest } = yield select(state => state.MyInvois);
                    yield put(
                        actions.readAllMyInvoisDocuments(lastReadAllDocumentsRequest),
                    );
                    yield take([
                        actions.MYINVOIS_READ_ALL_DOCUMENTS_SUCCESS,
                        actions.MYINVOIS_READ_ALL_DOCUMENTS_ERROR,
                    ]);

                    // OK
                    yield put({
                        type: actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS,
                        result: data.result,
                    });
                }
            });
    });
}

export function* cancelDocumentRequest() {
    yield takeEvery(actions.MYINVOIS_CANCEL_DOCUMENT_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ documentId }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_CANCEL_DOCUMENT_SUCCESS,
                    });
                }
                else {
                    yield call(post, `/myinvois/documents/${documentId}/cancel`, null, context);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_CANCEL_DOCUMENT_SUCCESS,
                    });
                }
            });
    });
}

export function* readAllTransactionsRequest() {
    yield takeEvery(actions.MYINVOIS_READ_ALL_TRANSACTIONS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_ALL_TRANSACTIONS_SUCCESS,
                        myInvoisTransactions: [
                            {
                                id: 102,
                                number: "BL-001",
                                date: "2024-08-04",
                                contact_legal_name: "Dummy contact",
                                currency_code: "RM",
                                exchange_rate: 1,
                                amount: 123,
                                type: "purchase_bill",
                                myinvois_action: "VALIDATE",
                                myinvois_document_status: 'ERROR',
                                is_myinvois_ready: true, // check product classification code
                                contact_is_myinvois_ready: true,
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                            },
                            {
                                id: 103,
                                number: "IV-002",
                                date: "2024-08-04",
                                contact_legal_name: "Dummy contact 2",
                                currency_code: "SGD",
                                exchange_rate: 3.45,
                                amount: 10.9,
                                type: "sale_invoice",
                                myinvois_action: "VALIDATE",
                                myinvois_document_status: "INVALID",
                                is_myinvois_ready: false, // check product classification code
                                contact_is_myinvois_ready: true,
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                            },
                            {
                                id: 155,
                                number: "IV-012",
                                date: "2024-08-04",
                                contact_legal_name: "Dummy contact 3",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 23.9,
                                type: "sale_invoice",
                                myinvois_action: "EXTERNAL",
                                myinvois_document_status: null,
                                is_myinvois_ready: false, // check product classification code
                                contact_is_myinvois_ready: false,
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                            },
                        ],
                        pagination: {
                            current_page: 1,
                            per_page: 30,
                            total: 23,
                        },
                        request,
                    });
                }
                else {
                    const response = yield call(get, '/myinvois/transactions', request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_ALL_TRANSACTIONS_SUCCESS,
                        myInvoisTransactions: data.myinvois_transactions,
                        pagination: data.paging,
                        request,
                    });
                }
            });
    });
}

export function* bulkSubmitTransactionsRequest() {
    yield takeEvery(actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ transactionIds }) {
                if (useDummyData) {
                    yield delay(1500);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS,
                        result: {
                            total_count: 12,
                        },
                    });
                }
                else {
                    const response = yield call(post, `/myinvois/transactions/submit`, { transaction_ids: transactionIds }, context);
                    const data = yield response.data;

                    // Re-read the list here, so that myInvoisTransactions is udpated once MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS,
                    // and myInvoisTransactions can be used in MyInvoisBulkSubmitTransactions' onSuccess as 'dataSource' if needed
                    const { lastReadAllTransactionsRequest } = yield select(state => state.MyInvois);
                    yield put(
                        actions.readAllMyInvoisTransactions(lastReadAllTransactionsRequest),
                    );
                    yield take([
                        actions.MYINVOIS_READ_ALL_TRANSACTIONS_SUCCESS,
                        actions.MYINVOIS_READ_ALL_TRANSACTIONS_ERROR,
                    ]);

                    // OK
                    yield put({
                        type: actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS,
                        result: data.result,
                    });
                }
            });
    });
}

export function* submitTransactionRequest() {
    yield takeEvery(actions.MYINVOIS_SUBMIT_TRANSACTION_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ transactionId, isSubmit }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_SUBMIT_TRANSACTION_SUCCESS,
                        isSubmit,
                    });
                }
                else {
                    yield call(post, `/myinvois/transactions/${transactionId}/submit`, null, context);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_SUBMIT_TRANSACTION_SUCCESS,
                        isSubmit, // used for message.success
                    });
                }
            });
    });
}

export function* readAllTransactionsForConsolidatedRequest() {
    yield takeEvery([
        actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST,
        actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST,
    ], function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: request.is_submittable ?
                            actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS :
                            actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS,
                        transactions: request.is_submittable ? [
                            {
                                id: 1,
                                number: "IV-00270",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 123,
                            },
                            {
                                id: 2,
                                number: "IV-00332",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 87,
                            },
                            {
                                id: 4,
                                number: "IV-00970",
                                date: "2024-08-04",
                                currency_code: "SGD",
                                exchange_rate: 3.143,
                                amount: 15,
                            },
                        ] : [
                            {
                                id: 98,
                                number: "IV-99270",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 123,
                            },
                            {
                                id: 97,
                                number: "IV-99332",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 87,
                            },
                        ],
                        pagination: {
                            current_page: 1,
                            per_page: request.page_size || 30,
                            total: request.is_submittable ? 123 : 98,
                        },
                        summary: {
                            transaction_count: request.is_submittable ? 123 : 987,
                            total_amount: 157.9,
                        },
                        isSubmittable: request.is_submittable,
                    });
                }
                else {
                    const response = yield call(get, '/myinvois/transactions/consolidated', request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: request.is_submittable ?
                            actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS :
                            actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS,
                        transactions: data.transactions,
                        pagination: data.paging,
                        summary: data.summary,
                        isSubmittable: request.is_submittable,
                    });
                }
            });
    });
}

export function* submitTransactionsForConsolidatedRequest() {
    yield takeEvery(actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST,
        function* (action, context) {
            yield requestSagaPushingFn(action,
                function* ({ request }) {
                    if (useDummyData) {
                        yield delay(1500);
                        // OK
                        yield put({
                            type: actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS,
                        });
                    }
                    else {
                        yield call(post, `/myinvois/transactions/consolidated`, request, context);
                        // OK
                        yield put({
                            type: actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS,
                        });
                    }
                });
        });
}

// MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_REQUEST saga
export function* refetchTransactionDocumentStatusRequest() {
    yield takeEvery(
        actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_REQUEST, function* (action, context) {
            yield requestSagaPullingFn(action,
                function* ({ id, transactionType }) {
                    const baseUrl = getServerUrl(transactionType);
                    if (!baseUrl)
                        throw new Error(`Unsupported transactionType: ${transactionType}`);
                    const url = `${baseUrl}/${id}/myinvois_document_status`;
                    const response = yield call(get, url, null, context);
                    const data = yield response.data;
                    yield put({
                        type: actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_SUCCESS,
                        transactionDocumentStatus: data.document_status,

                    });
                },
            );
        });
}

// myInvoisDocumentStatusRefetchState
export function* refetchMyInvoisDocumentStatusRequest() {
    yield takeEvery(actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const url = `/myinvois/documents/${id}/status`;
                const response = yield call(get, url, null, context);
                const data = yield response.data;
                yield put({
                    type: actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_SUCCESS,
                    documentStatus: data.document_status,
                });
            });
    });
}

// MiniPOS
export function* readAllMiniPosRequest() {
    yield takeEvery(actions.MYINVOIS_READ_ALL_MINIPOS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_ALL_MINIPOS_SUCCESS,
                        myInvoisMiniPos: [
                            {
                                id: 102,
                                number: "BL-001",
                                date: "2024-08-04",
                                contact_legal_name: "Dummy contact",
                                currency_code: "RM",
                                exchange_rate: 1,
                                amount: 123,
                                type: "purchase_bill",
                                myinvois_action: "VALIDATE",
                                myinvois_document_status: 'ERROR',
                                is_myinvois_ready: true, // check product classification code
                                contact_is_myinvois_ready: true,
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                            },
                            {
                                id: 103,
                                number: "IV-002",
                                date: "2024-08-04",
                                contact_legal_name: "Dummy contact 2",
                                currency_code: "SGD",
                                exchange_rate: 3.45,
                                amount: 10.9,
                                type: "sale_invoice",
                                myinvois_action: "VALIDATE",
                                myinvois_document_status: "INVALID",
                                is_myinvois_ready: false, // check product classification code
                                contact_is_myinvois_ready: true,
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                            },
                            {
                                id: 155,
                                number: "IV-012",
                                date: "2024-08-04",
                                contact_legal_name: "Dummy contact 3",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 23.9,
                                type: "sale_invoice",
                                myinvois_action: "EXTERNAL",
                                myinvois_document_status: null,
                                is_myinvois_ready: false, // check product classification code
                                contact_is_myinvois_ready: false,
                                created_at: "2024-08-04 14:19:42",
                                updated_at: "2024-08-04 14:19:42",
                            },
                        ],
                        pagination: {
                            current_page: 1,
                            per_page: 30,
                            total: 23,
                        },
                        request,
                    });
                }
                else {
                    const response = yield call(get, '/minipos/myinvois/orders', request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_ALL_MINIPOS_SUCCESS,
                        myInvoisMiniPos: data.myinvois_orders,
                        pagination: data.paging,
                        request,
                    });
                }
            });
    });
}

export function* bulkSubmitMiniPosRequest() {
    yield takeEvery(actions.MYINVOIS_BULK_SUBMIT_MINIPOS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ orderIds }) {
                if (useDummyData) {
                    yield delay(1500);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS,
                        result: {
                            total_count: 12,
                        },
                    });
                }
                else {
                    const response = yield call(post, `/minipos/myinvois/orders/submit`, { order_ids: orderIds }, context);
                    const data = yield response.data;

                    // Re-read the list here, so that myInvoisTransactions is udpated once MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS,
                    // and myInvoisTransactions can be used in MyInvoisBulkSubmitTransactions' onSuccess as 'dataSource' if needed
                    const { lastReadAllMiniPosRequest } = yield select(state => state.MyInvois);
                    yield put(
                        actions.readAllMyInvoisMiniPos(lastReadAllMiniPosRequest),
                    );
                    yield take([
                        actions.MYINVOIS_READ_ALL_MINIPOS_SUCCESS,
                        actions.MYINVOIS_READ_ALL_MINIPOS_ERROR,
                    ]);

                    // OK
                    yield put({
                        type: actions.MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS,
                        result: data.result,
                    });
                }
            });
    });
}

export function* submitMiniPosRequest() {
    yield takeEvery(actions.MYINVOIS_SUBMIT_MINIPOS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ transactionId, isSubmit }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_SUBMIT_MINIPOS_SUCCESS,
                        isSubmit,
                    });
                }
                else {
                    yield call(post, `/minipos/myinvois/orders/${transactionId}/submit`, null, context);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_SUBMIT_MINIPOS_SUCCESS,
                        isSubmit, // used for message.success
                    });
                }
            });
    });
}

export function* readAllMiniPosForConsolidatedRequest() {
    yield takeEvery([
        actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_REQUEST,
    ], function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: request.is_submittable ?
                            actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_SUCCESS :
                            actions.MYINVOIS_READ_UNSUBMITTABLE_MINIPOS_FOR_CONSOLIDATED_SUCCESS,
                        transactions: request.is_submittable ? [
                            {
                                id: 1,
                                number: "IV-00270",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 123,
                            },
                            {
                                id: 2,
                                number: "IV-00332",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 87,
                            },
                            {
                                id: 4,
                                number: "IV-00970",
                                date: "2024-08-04",
                                currency_code: "SGD",
                                exchange_rate: 3.143,
                                amount: 15,
                            },
                        ] : [
                            {
                                id: 98,
                                number: "IV-99270",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 123,
                            },
                            {
                                id: 97,
                                number: "IV-99332",
                                date: "2024-08-04",
                                currency_code: "MYR",
                                exchange_rate: 1,
                                amount: 87,
                            },
                        ],
                        pagination: {
                            current_page: 1,
                            per_page: request.page_size || 30,
                            total: request.is_submittable ? 123 : 98,
                        },
                        summary: {
                            transaction_count: request.is_submittable ? 123 : 987,
                            total_amount: 157.9,
                        },
                        isSubmittable: request.is_submittable,
                    });
                }
                else {
                    const response = yield call(get, '/minipos/myinvois/orders/consolidated', request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_SUCCESS,
                        orders: data.orders,
                        pagination: data.paging,
                        summary: data.summary,
                    });
                }
            });
    });
}

export function* submitMiniPosForConsolidatedRequest() {
    yield takeEvery(actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_REQUEST,
        function* (action, context) {
            yield requestSagaPushingFn(action,
                function* ({request}) {
                    if (useDummyData) {
                        yield delay(1500);
                        // OK
                        yield put({
                            type: actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_SUCCESS,
                        });
                    }
                    else {
                        yield call(post, `/minipos/myinvois/orders/consolidated`, request, context);
                        // OK
                        yield put({
                            type: actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_SUCCESS,
                        });
                    }
                });
        });
}

export function* validateTinRegNoRequest() {
    yield takeEvery(actions.MYINVOIS_VALIDATE_TIN_REG_NO_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MYINVOIS_VALIDATE_TIN_REG_NO_SUCCESS,
                        isValid: false,
                    });
                }
                else {
                    const response = yield call(get, '/myinvois/validate_tin', request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MYINVOIS_VALIDATE_TIN_REG_NO_SUCCESS,
                        isValid: data.is_valid,
                    });
                }
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(readDocumentRequest),
        fork(readAllDocumentsRequest),
        fork(resubmitDocumentRequest),
        fork(bulkResubmitDocumentsRequest),
        fork(cancelDocumentRequest),

        // Transactions
        fork(readAllTransactionsRequest),
        fork(bulkSubmitTransactionsRequest),
        fork(submitTransactionRequest),
        fork(readAllTransactionsForConsolidatedRequest),
        fork(submitTransactionsForConsolidatedRequest),

        // MiniPOS
        fork(readAllMiniPosRequest),
        fork(bulkSubmitMiniPosRequest),
        fork(submitMiniPosRequest),
        fork(readAllMiniPosForConsolidatedRequest),
        fork(submitMiniPosForConsolidatedRequest),

        //Incoming Document
        fork(readIncomingDocumentRequest),
        fork(postIncomingDocumentRequest),
        fork(readAllIncomingDocumentsRequest),
        fork(deleteIncomingDocumentsRequest),

        fork(validateTinRegNoRequest),

        // MyInvois Document Status
        fork(refetchTransactionDocumentStatusRequest), // for transaction
        fork(refetchMyInvoisDocumentStatusRequest), // for myinvois document

        //
    ]);
}
